module.exports = __webpack_public_path__ + "images/ic_menu_white_24px.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ic_menu_white_24px.svg
 ** module id = 58
 ** module chunks = 1
 **/